export enum EOwnerStatus {
    CREATED = 'created',
    REGENERATING = 'regenerating',
    REGENERATED = 'regenerated',
    FAILED_TO_REGENERATE = 'failed_to_regenerate',
    SENDING = 'sending',
    FAILED_TO_SEND = 'failed_to_send',
    // inactive
    SENT = 'sent',
    SKIPPED = 'skipped',
}

export interface IOwnerPerformance {
    id: number;
    label: string;
    status: EOwnerStatus;
    reason: string;
}
export interface IOwnerStrategy {
    id: number;
    label: string;
    status: EOwnerStatus;
}

export interface IOwner {
    fsm_id: number;
    fsm_name: string;
    owner_id: string;
    owner_name: string;
    owner_email: string;
    performance: IOwnerPerformance;
    strategy: IOwnerStrategy;
}

export interface IMonthlyBoardResponse {
    count: number;
    next: null | undefined;
    previous: null | undefined;
    results: Array<IOwner>;
}
